import type { Customer as GQLItem } from '../../../generated/internal.graphql';

/**
 * A customer as the internal (VP staff) schema returns it.
 *
 * Every contact field is nullable here, unlike AppSchema's `Customer` where they are non-null —
 * a staff read spans accounts and reaches records the tenant-facing schema never exposes. That is
 * also why this mapper cannot use `take`: it skips `undefined` but passes `null` straight through,
 * which would leak `null` into a `string | undefined` field.
 *
 * `accounts` and `createdAt` are deliberately not mapped — no page in the staff order screens
 * renders them.
 */
export type Customer = {
  id: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
};

export const fromGql = (item: GQLItem): Customer => ({
  id: item.id,
  email: item.email ?? undefined,
  firstName: item.firstName ?? undefined,
  lastName: item.lastName ?? undefined,
  phoneNumber: item.phoneNumber ?? undefined,
});
